export type SelectedLocality = { label: string; value: string };

// Selecting a locality navigates to its search page (full remount), so the
// multi-selection has to survive outside component state. Shared with
// getFilterLabel so the badge can show "First +N".
export const LOCALITY_SELECTION_KEY = "amber_locality_multi_select";

export const readStoredSelection = (): SelectedLocality[] => {
  if (typeof window === "undefined") return [];
  try {
    const stored = JSON.parse(window.sessionStorage.getItem(LOCALITY_SELECTION_KEY) || "[]");
    return Array.isArray(stored) ? stored : [];
  } catch {
    return [];
  }
};

export const clearStoredSelection = (): void => {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(LOCALITY_SELECTION_KEY);
};
